/* SPN Anker
   Sprungziele in JSON-Vorlagen heissen im Seitenquelltext
   shopify-section-template--<zahl>__<schluessel>. In den Einstellungen steht
   aber nur #shopify-section-<schluessel>. Diese Datei loest das auf:
   sie sucht die passende Sektion und springt dorthin. Findet sie keine,
   wird der Knopf ausgeblendet, damit nichts ins Leere fuehrt. */
(function () {
  var VOR = 'shopify-section-';
  var ABSTAND = 90;

  function suchen(name) {
    if (!name) return null;
    var direkt = document.getElementById(name);
    if (direkt) return direkt;
    if (name.indexOf(VOR) !== 0) return null;
    var schluessel = name.slice(VOR.length);
    if (!schluessel) return null;
    var alle = document.querySelectorAll('[id^="' + VOR + '"]');
    for (var i = 0; i < alle.length; i++) {
      var id = alle[i].id;
      if (id === name) return alle[i];
      if (id.length > schluessel.length + 2 && id.slice(-(schluessel.length + 2)) === '__' + schluessel) {
        return alle[i];
      }
    }
    return null;
  }

  function springen(el) {
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - ABSTAND;
    if (y < 0) y = 0;
    try {
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, y);
    }
  }

  function pruefen() {
    var links = document.querySelectorAll('a[href*="#' + VOR + '"]');
    for (var i = 0; i < links.length; i++) {
      (function (a) {
        var raute = a.getAttribute('href').indexOf('#');
        var name = a.getAttribute('href').slice(raute + 1);
        var ziel = suchen(name);
        if (!ziel) {
          a.setAttribute('hidden', 'hidden');
          a.style.display = 'none';
          return;
        }
        a.setAttribute('href', '#' + ziel.id);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          springen(ziel);
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#' + ziel.id);
          }
        });
      })(links[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruefen);
  } else {
    pruefen();
  }
})();